export const darkTitle = '#282828';
export const mediumTitle = '#0a1f44';
// export const mediumTitle = '#5e7d8c';

export const lightTitle = '#657081';

export const error = '#D0021B';
